import lapdev from '../../lapdev';

export function confirmInvitation(data) {
  return lapdev.post('users/confirm-invitation', data);
}
